export default __webpack_public_path__ + "static/media/Nereu Afonso_.d27135f8.png";